/* global mixpanel */
import formatDate from 'mixpanel/formatDate'

export function inventoryAdjustmentStart ({outletIds, startDate, endDate, namespace}) {
  mixpanel.track('Inventory Adjustment Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  })
}

export function inventoryAdjustmentChangeFilter ({outletIds, startDate, endDate, namespace}) {
  mixpanel.track('Inventory Adjustment Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  })
}

export function inventoryAdjustmentCreate ({adjustment, outlet}) {
  const mixpanelData = {
    'Outlet Name': outlet.name
  }
  let namespace
  if (adjustment.hasOwnProperty('history_details')) {
    namespace = 'items'
    mixpanelData['List of Items'] = adjustment.history_details.map(d => ({
      'Name': d.item_name,
      'Variant': d.item_variant_name,
      'Previous Qty': d.beginning_stock,
      'New Qty': d.quantity
    }))
  } else {
    mixpanelData['List of Ingredients'] = adjustment.ingredient_history_details.map(d => ({
      'Name': d.ingredient_name,
      'Previous Qty': d.beginning_stock,
      'New Qty': d.quantity
    }))
    namespace = 'ingredients'
  }
  mixpanelData['Current Inventory Filter'] = namespace
  mixpanel.track('Inventory Adjustment Create', mixpanelData)
}

export function inventoryAdjustmentExport ({outletIds, startDate, endDate, namespace}) {
  const mixpanelData = {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Inventory Filter': namespace
  }
  mixpanel.track('Inventory Adjustment Export', mixpanelData)
}

export function inventoryAdjustmentImport ({namespace}) {
  mixpanel.track('Inventory Adjustment Import', {
    'Current Inventory Filter': namespace
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/inventory/adjustment.js